import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';

const CompliancePredesDestinationImpcCodeNotRegisteredReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.PREDES_DESTINATION_IMPC_CODE_NOT_REGISTERED_DETAILS.id,
        label: 'DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default CompliancePredesDestinationImpcCodeNotRegisteredReport;

CompliancePredesDestinationImpcCodeNotRegisteredReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
